import { createReducer } from "@reduxjs/toolkit";
import type { UpdateState } from "@redux/state/shared-types";
import { resetUpdateProviderSettings, updateProviderSettings } from "./update-provider-settings";

const initialState: UpdateState = { justUpdatedId: null, processing: "idle" };

export const updateProviderSettingsReducer = createReducer<UpdateState>(initialState, builder => {
  builder.addCase(updateProviderSettings.fulfilled, (state, { payload }) => {
    return {
      ...state,
      justUpdatedId: payload,
      processing: "success",
    };
  });
  builder.addCase(updateProviderSettings.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateProviderSettings.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateProviderSettings, () => {
    return initialState;
  });
});
